import { call, fork, put, takeEvery } from 'redux-saga/effects';
import { v4 as uuidv4 } from 'uuid';
import { notificationInit } from '../../modules/notifications/actions';
import { getWaysListRequest } from '../../api/ways-requests';
import { REQUEST_ERROR_MESSAGE } from './constants';
import { DISMISS_TIME } from '../../api/constants';
import { GET_WAYS_LIST, setWaysListAction, setIsWaysListLoadingAction, setPaginationAction } from './actions';
import { errorHandler } from '../../api/utils';

export function* getWaysListSaga({ payload: { searchQuery, noLoading } }) {
	try {
		if (!noLoading) {
			yield put(setIsWaysListLoadingAction(true));
		}
		const { data, meta, message, toast } = yield call(getWaysListRequest, searchQuery);

		if (data) {
			if (toast) {
				yield put(notificationInit({ id: uuidv4(), dismissAfter: DISMISS_TIME, ...toast }));
			}

			yield put(
				setWaysListAction(
					data?.map(way => ({
						...way,
						link: `?${searchQuery ? `${searchQuery}&` : ''}modal=way&id=${way.id}`,
						address_from: way?.points[0]?.address,
						date_from: way?.points[0]?.date,
						address_to: way?.points[way.points.length - 1]?.address,
						date_to: way?.points[way.points.length - 1]?.date,
					})),
				),
			);

			if (meta) {
				yield put(
					setPaginationAction({
						current_page: meta.current_page,
						per_page: meta.per_page,
						from: meta.from,
						last_page: meta.last_page,
						total: meta.total,
					}),
				);
			}
		} else {
			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsWaysListLoadingAction(false));
	}
}

export default function* waysContainerSaga() {
	yield takeEvery(GET_WAYS_LIST, getWaysListSaga);
}
